/** @format */

import { HeaderCheckBoxSelectListElement } from '../../lib/search/listTableHeader/HeaderCheckBoxSelectList';
import MvnoBlockRequest from '../../../interfaces/platform/MvnoBlockRequest';

export const LegendMapInt = {
    IN_PROGRESS: 1,
    CALL_SUB_BLOCK: 2,
    CANCELED: 3,
    ERROR: 4,
    FINISH: 5,
    RENEWAL: 6,
};

export const LegendMapInt18n = {
    IN_PROGRESS: 'prov:list.request_in_progress',
    CALL_SUB_BLOCK: 'prov:list.call_sub_block',
    CANCELED: 'prov:list.request_canceled',
    ERROR: 'prov:list.request_error_state',
    FINISH: 'prov:list.request_finish',
    RENEWAL: 'prov:list.renewal_block',
};

export class BlockViewStateType {
    getTypes = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { name: LegendMapInt18n.FINISH, value: LegendMapInt.FINISH },
            { name: LegendMapInt18n.IN_PROGRESS, value: LegendMapInt.IN_PROGRESS },
            { name: LegendMapInt18n.CALL_SUB_BLOCK, value: LegendMapInt.CALL_SUB_BLOCK },
            { name: LegendMapInt18n.RENEWAL, value: LegendMapInt.RENEWAL },
            { name: LegendMapInt18n.CANCELED, value: LegendMapInt.CANCELED },
            { name: LegendMapInt18n.ERROR, value: LegendMapInt.ERROR },
        ];
    };

    getState = (item: MvnoBlockRequest): string | null => {
        if (item.blockFullyRestarted) {
            return LegendMapInt18n.RENEWAL;
        }
        if (item.cancel) {
            return LegendMapInt18n.CANCELED;
        }
        if (item.errorState) {
            return LegendMapInt18n.ERROR;
        }
        if (item.awaitingRequestId) {
            return LegendMapInt18n.CALL_SUB_BLOCK;
        }
        if (!item.requestEnd && !item.errorState && item.startProcessAt) {
            return LegendMapInt18n.IN_PROGRESS;
        }
        if (item.requestEnd && !item.errorState && !item.cancel) {
            return LegendMapInt18n.FINISH;
        }
        return null;
    };
}
